import {
  alignmentStyles,
  AlignmentStylesProps,
} from 'component-library/styles/alignment';
import { colorStyle, ColorStyleProps } from 'component-library/styles/colors';
import { SpacingProps, spacingStyles } from 'component-library/styles/spacing';
import { css } from 'styled-components';

export interface TypographyStylesProps
  extends ColorStyleProps,
    SpacingProps,
    AlignmentStylesProps {}

export const typographyStyles = css<TypographyStylesProps>`
  ${colorStyle}
  ${spacingStyles}
  ${alignmentStyles}
`;
